import styled, { css } from "styled-components";
const TableDataCell = styled.td(
  ({ $isNumeric, theme }) => css`
    ${$isNumeric ? `font-family: ${theme.fonts.family.monospace};` : ""}
    ${$isNumeric ? "text-align: right" : ""}
  `
);
export default TableDataCell;
